import React from 'react';
import BaseActionForm from '../BaseActionForm';
import { Button, Dropdown } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import './styles.scss'
import { useNavigate, useLocation } from 'react-router-dom'
import DropdownWithFilter from './../../components/DropdownWithFilter';
import BackArrow from './../../assets/BackArrow.svg'

export default function Decomposer(props) {
    const navigation = useNavigate() // extract navigation prop here 
    const { state } = useLocation();
    return <DecomposerClass {...props} dataset={props.choosenDataset? props.choosenDataset : (state && state.params && state.params.D_dataset)} navigation={navigation} /> //pass to your component.
}

class DecomposerClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            myDatasets: null,
            dataset: null,
            fields: null,
            selectedField: null,
            onErrorWithProcesses: false
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        this.startLoading();
        let response = await Promise.all([
            ApiService.getMyDatasets()
        ]);
        this.stopLoading();
        if (this.checkStatus(response)) {
            this.setState({
                myDatasets: response[0].datasets
            }, () => {
                this.props.dataset && this.handleDatasetSelect(this.props.dataset)
            });
        }
    }

    handleDatasetSelect = (dataset) => {
        let stringFields = [];
        if (dataset) {
            dataset.fields.forEach((field) => {
                if (field.type === "string") {
                    stringFields.push(field);
                }
            });
        }
        this.setState(
            {
                dataset: dataset,
                fields: stringFields,
                selectedField: null
            }, () => {
                if (dataset && ApiService.checkActiveProcess(dataset, 'lk_decomposer')) {
                    this.setState({ onErrorWithProcesses: true })
                }
                this.datasetProcessCheck(dataset)
            }
        );
    }
    updateAndCheckDataset = (dataset) => {
        if (dataset) {
            ApiService.getMyDatasets().then((response) => {
                if (this.checkStatus(response)) {

                    response.datasets.forEach((newDataset) => {
                        if (newDataset._id["$oid"] === dataset._id["$oid"]) {
                            this.setState({
                                dataset: newDataset,
                                onErrorWithProcesses: ApiService.checkActiveProcess(newDataset, 'lk_decomposer')
                            });
                        }
                    })
                }

                this.stopLoading();
            });
        }
    }
    datasetProcessCheck = (dataset) => {
        this.checkInterval && clearInterval(this.checkInterval);
        if (dataset) {
            this.checkInterval = setInterval(() => {
                this.startLoading();
                this.updateAndCheckDataset(dataset)
            }, 5000);
        }
    }

    handleFieldSelect = (field) => {
        this.setState({ selectedField: field });
    }

    onStartProcess = () => {
        if (this.state.dataset && !this.state.onErrorWithProcesses && this.state.selectedField) {
            ApiService.createLKDecomposerTask(this.state.dataset.dataset, this.state.selectedField.name).then((response) => {
                this.setState({ processResult: response, onErrorWithProcesses: true });
                setTimeout(() => { this.setState({ processResult: null }) }, 5000);
            });
        }
    }

    render() {

        console.log(this.state)
        return (

            <div className='twoHalfs'>
                <div id={"decomposer"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <div className="headerContainer">
                        {this.props && !this.props.dataset && <img src={BackArrow} className='backArrow' alt='back arrow' onClick={() => this.props.navigation(-1)} />}
                        <div className='titleContainer'><p className="headerMargin">Разбор адреса</p></div>
                    </div>


                    {this.props && this.props.dataset && <div className="bottomHeaderContainer">
                        <p>{this.props.dataset.name}</p>
                    </div>}

                    {/* <Button variant="primary" className="chooseImportFileDecomposer" onClick={() => { this.goToSection(this.props.navigation, "MyDatasets"); }}>к списку загруженных наборов</Button> */}
                    <div className="postHeaderContainer textRoboto infoContainer">

                        {this.state.myDatasets && !this.props.dataset &&
                            <>
                                <p className="textBottom">Hабор данных</p>
                                <DropdownWithFilter
                                    className="dropSelectDataset"
                                    items={this.state.myDatasets}
                                    selectedItem={this.state.dataset}
                                    onItemClick={(item) => { this.handleDatasetSelect(item) }}
                                    label={(item) => { return item.name || "(не установлено)"; }}
                                    defaultLabel={"Выберите"}
                                />
                            </>
                        }

                        {this.state.fields && this.state.dataset &&
                            <>
                                <p className="textBottom">Bыберите поле для разбора адреса</p>
                                <Dropdown className="dropDecomposer">
                                    <Dropdown.Toggle className="dropdownButtonDecomposer" variant="success" id="dropdown-basic">
                                        {this.state.selectedField ? this.state.selectedField.caption : "Варианты разбора"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {this.state.fields.map((field, index) => (
                                            <Dropdown.Item key={index} onClick={() => { this.handleFieldSelect(field) }}>{field.caption}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        }
                    </div>


                    {
                        (this.state.processResult)
                            ?
                            <div className='textBottom'>
                                {(this.state.processResult.status === "success")
                                    ?
                                    <div>
                                        <p className='textBottom'>Запущен процесс разбора адреса</p>    
                                    </div>
                                    :
                                    <p className='textBottom'>Произошла ошибка: {this.state.processResult.errorMessageRu}</p>
                                }
                            </div>
                            :
                            (this.state.dataset && this.state.selectedField) &&
                            <Button className='applyInstrument' style={this.state.onErrorWithProcesses ? { opacity: '0.3', pointerEvents: 'none' } : { opacity: '1' }} onClick={this.onStartProcess}>Запустить разбор адреса</Button>
                    }
                    <p className={'infoProcesses textBottom'} style={this.state.onErrorWithProcesses ? { display: 'inline' } : { display: 'none' }}> Дождитесь завершения запущенных процессов </p>

                </div>

                <div className='rightHalf'></div>

            </div>
        );
    }
}

